import React, { useState } from 'react';
import Form from '../../components/common/Form';
import FormSection from '../../components/common/FormSection';
import FormField from '../../components/common/FormField';
import { InvoiceStatusDTO } from '../../services/apiClient';
import handleChange from '../../utils/formUtils/handleChange';
import { useFormValidation, ValidationRules } from '../../hooks/useFormValidation';

interface InvoiceStatusFormProps {
  initialValues: InvoiceStatusDTO;
  onSubmit: (data: InvoiceStatusDTO) => void;
  onCancel: () => void;
  isLoading?: boolean;
}

const FORM_SECTIONS = {
  basicInfo: {
    id: 'basic-info',
    title: 'Basic Information'
  }
} as const;

const InvoiceStatusForm: React.FC<InvoiceStatusFormProps> = ({
  initialValues,
  onSubmit,
  onCancel,
  isLoading = false
}) => {
  const [formData, setFormData] = useState<InvoiceStatusDTO>(initialValues);

  
            const validationRules: ValidationRules = {
                    name: [
      { required: true, message: 'Name is required' }
    ]
            };

  const { errors, validate } = useFormValidation<InvoiceStatusDTO>(validationRules);

  const handleSave = () => {
    if (validate(formData)) {
      onSubmit(formData);
    }
  };

  const sections = Object.values(FORM_SECTIONS);

  return (
    <Form sections={sections} onSave={handleSave} onCancel={onCancel} isSubmitting={isLoading}>
      <FormSection 
        id={FORM_SECTIONS.basicInfo.id} 
        title={FORM_SECTIONS.basicInfo.title}
      >
                <FormField
          id="name"
          label="Name"
          type="text"
          value={formData.name || ''}
          onChange={(e) => handleChange(e, setFormData)}
          placeholder="Enter Name"
          required={true}
          error={errors.name}
        />
        <FormField
          id="description"
          label="Description"
          type="text"
          value={formData.description || ''}
          onChange={(e) => handleChange(e, setFormData)}
          placeholder="Enter Description"
          required={false}
          error={errors.description}
        />

      </FormSection>
    </Form>
  );
};

export default InvoiceStatusForm;